import { useEffect, useRef, useState } from 'react'
import { copySubstackShareText } from '../lib/api.js'

const HINT_MS = 3000
const REDIRECT_DELAY_MS = 1500

export default function SubstackShareButton({ event, className, iconSize = 'h-4 w-4' }) {
  const [copied, setCopied] = useState(false)
  const hintTimer = useRef(null)
  const openTimer = useRef(null)

  useEffect(() => () => {
    if (hintTimer.current) clearTimeout(hintTimer.current)
    if (openTimer.current) clearTimeout(openTimer.current)
  }, [])

  const onClick = async () => {
    const { url } = await copySubstackShareText(event)
    setCopied(true)
    if (hintTimer.current) clearTimeout(hintTimer.current)
    hintTimer.current = setTimeout(() => setCopied(false), HINT_MS)
    if (url) {
      if (openTimer.current) clearTimeout(openTimer.current)
      openTimer.current = setTimeout(() => {
        window.open(url, '_blank', 'noopener,noreferrer')
      }, REDIRECT_DELAY_MS)
    }
  }

  return (
    <span className="relative inline-flex">
      <button
        type="button"
        onClick={onClick}
        aria-label="Share on Substack"
        title="Share on Substack"
        className={className}
      >
        <svg className={iconSize} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/>
        </svg>
      </button>
      {copied ? (
        <span
          role="status"
          className="pointer-events-none absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap rounded bg-slate-900/85 px-2 py-0.5 text-[10px] font-medium text-white shadow"
        >
          Copied — paste into Substack
        </span>
      ) : null}
    </span>
  )
}
